import { Inventory2Rounded as Inventory2RoundedIcon } from '@mui/icons-material'
import {
  Autocomplete,
  CircularProgress,
  Icon,
  InputAdornment,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  TextField,
  Typography
} from '@mui/material'
import { t } from 'i18next'
import { useEffect, useState } from 'react'

import { useFilters } from '../../Contexts/FiltersContext'

const BrandsFilter = ({ filters = {}, onChange }) => {
  const { useFetchBrandsFilters } = useFilters()

  const [brandsFilterOptions, setBrandsFiltersOptions] = useState([])
  const [isBrandsFilterLoading, setIsBrandsFilterLoading] = useState(false)

  const handleChange = (_, value) => {
    const brandNamesEncoded = value.map((i) => i.nameEncoded)
    onChange({ brandNamesEncoded })
  }

  useEffect(() => {
    setIsBrandsFilterLoading(true)

    useFetchBrandsFilters(brandNamesEncoded)
      .then(({ data }) => setBrandsFiltersOptions(data))
      .finally(() => setIsBrandsFilterLoading(false))
  }, [])

  const { brandNamesEncoded = [] } = filters

  return (
    <>
      <Stack
        direction="column"
        justifyContent="space-between"
        alignItems="left"
        spacing={2}
        mt={3}
        mb={3}
      >
        <Typography
          align="left"
          sx={{ fontWeight: 'bold' }}
        >
          {t('filters.devices.other.brands.label')}
        </Typography>
        <Autocomplete
          multiple
          disabled={isBrandsFilterLoading}
          id="brands-filter"
          options={brandsFilterOptions}
          onChange={handleChange}
          isOptionEqualToValue={(option, value) => option.nameEncoded === value.nameEncoded}
          loading={isBrandsFilterLoading}
          getOptionLabel={(option) => option.name}
          value={brandsFilterOptions.filter(({ nameEncoded }) => brandNamesEncoded.includes(nameEncoded))}
          renderOption={(props, option) => (
            <ListItem
              {...props}
              divider
              key={option.nameEncoded}
            >
              <ListItemIcon>
                <Inventory2RoundedIcon fontSize="large" />
              </ListItemIcon>
              <ListItemText
                primary={option.name}
              />
            </ListItem>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder={t('filters.devices.other.brands.placeholder')}
              label={t('filters.devices.other.brands.placeholder')}
              slotProps={{
                ...params.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    <Icon
                      color="inherit"
                      edge="end"
                    >
                      {isBrandsFilterLoading && (
                        <CircularProgress
                          edge="end"
                          size={20}
                        />
                      )}
                    </Icon>
                  </InputAdornment>
                )
              }}
            />
          )}
        />
      </Stack>
    </>
  )
}

export default BrandsFilter
